import { useSelector } from 'react-redux';
import { RootState } from '../app/store';
import { useAuth } from './useAuth';
import { Usuario } from '../types/Usuario';

export const useUserLogin = () => {
  const { login } = useAuth();
  const { usuarioLogin } = useSelector(
    (state: RootState) => state.auth
  );

  const getUsuario = (): Usuario | undefined => {
    // Primero intentar obtener del Redux store (nuevo sistema Cognito)
    if (usuarioLogin && Object.keys(usuarioLogin).length > 0) {
      return usuarioLogin;
    }

    // Fallback al localStorage (sistema antiguo)
    try {
      const loginData = JSON.parse(
        localStorage.getItem('login') || '{}'
      );
      return loginData?.usuario || null;
    } catch {
      return undefined;
    }
  };

  const isContratistaTipoUsuario = (): boolean => {
    const usuario = getUsuario();
    return usuario?.tipoUsuarioValor === 'CONTRATISTA';
  };

  const isEmpresaGestoraTipoUsuario = (): boolean => {
    const usuario = getUsuario();
    return usuario?.tipoUsuarioValor === 'EMPRESA_GESTORA';
  };

  const isSistemaTipoUsuario = (): boolean => {
    const usuario = getUsuario();
    return usuario?.tipoUsuarioValor === 'SISTEMA';
  };

  const getUsuarioLocalStorage = (): Usuario | undefined => {
    // Ahora retorna el usuario desde el store o localStorage
    return getUsuario();
  };

  // Función adicional para verificar si hay un usuario logueado
  const isUserLoggedIn = (): boolean => {
    const usuario = getUsuario();
    return usuario !== undefined && Object.keys(usuario).length > 0;
  };

  return {
    login,
    usuarioLogin,
    isContratistaTipoUsuario,
    isEmpresaGestoraTipoUsuario,
    isSistemaTipoUsuario,
    getUsuarioLocalStorage,
    getUsuario,
    isUserLoggedIn,
    // Otras funciones relacionadas con usuarios
  };
};
